import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import Vuetify from "vuetify";
import "../node_modules/vuetify/dist/vuetify.min.css";
import VueAxios from "vue-axios";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import ReadMore from 'vue-read-more'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
import VueSocketio from 'vue-socket.io'
import { languages } from './plugins/lang.js'
import { defaultLocale } from './plugins/lang.js'
import VueSweetalert2 from 'vue-sweetalert2'
import * as VueGoogleMaps from 'vue2-google-maps'
// import x5GMaps from 'x5-gmaps'
const messages = Object.assign(languages)
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import VideoPlayer from 'vue-video7'
import AudioVisual from 'vue-audio-visual'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(ReadMore)
Vue.use(VueSocketio, process.env.VUE_APP_API_SOCKET)
Vue.use(VueSweetalert2)
Vue.use(Antd)
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g',
    placeid: 'ChIJ4ZnvKX274jARFsZN_d404sI',
    key: 'AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic',
    libraries: 'places' // necessary for places input
  }
})
Vue.use(VideoPlayer)
Vue.use(AudioVisual)
Vue.use(VuePlyr, {
  plyr: {}
})

// Vue.use(x5GMaps, { key: 'AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g', libraries: ['places'] })
var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'th',
  messages
})
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
